import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const ColaboradorForm = ({ show, handleClose, collaborator, onSave }) => {
  const initialFormData = {
        nombre: '',
        apellido: '',
        cedula: '',
        codigo: '',
        esFijo: false,
        esAuxiliar: false,
   };


  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (collaborator) {
      setFormData(collaborator);
    } else {
      setFormData({
        nombre: '',
        apellido: '',
        cedula: '',
        codigo: '',
        esFijo: false,
        esAuxiliar: false,
      });
    }
  }, [collaborator,show]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleRadioChange = (e) => {
    const { name } = e.target;
    setFormData({
      ...formData,
      esFijo: name === 'esFijo',
      esAuxiliar: name === 'esAuxiliar',
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    onSave(formData);
    setFormData(initialFormData); // Reset form
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{collaborator ? 'Actualizar Colaborador' : 'Registrar Colaborador'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Nombre</Form.Label>
            <Form.Control
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Apellido</Form.Label>
            <Form.Control
              type="text"
              name="apellido"
              value={formData.apellido}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Cédula</Form.Label>
            <Form.Control
              type="text"
              name="cedula"
              value={formData.cedula}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Código</Form.Label>
            <Form.Control
              type="text"
              name="codigo"
              value={formData.codigo}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              label="Es Fijo"
              name="esFijo"
              checked={formData.esFijo}
              onChange={handleRadioChange}
            />
            <Form.Check
              type="radio"
              label="Es Auxiliar"
              name="esAuxiliar"
              checked={formData.esAuxiliar}
              onChange={handleRadioChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
        <Button variant="secondary" onClick={() => {
            handleClose();
            setFormData(initialFormData); // Reset form data on close
          }}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit">
            Guardar
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ColaboradorForm;
